<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { NXGDSButton, NXGDSButtonVariants, NXGDSButtonSizes } from '@nsftx/seven-nxg-design-system'
import router from '@/router'

const openTermsAndConditions = (isActive: boolean) => {
  if (isActive) router.back()
  else router.push({ name: 'termsAndConditions' })
}
</script>

<template>
  <RouterLink v-slot="{ isActive }" to="/terms-and-conditions" custom>
    <NXGDSButton
      width="56px"
      data-cy="TermsAndConditionFooterButton"
      :variant="NXGDSButtonVariants.secondary"
      :size="NXGDSButtonSizes.big"
      icon="eighteen"
      @click="openTermsAndConditions(isActive)"
    />
  </RouterLink>
</template>
